module.exports = __webpack_public_path__ + "static/images/biditem3_65ecd2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem3.png
// module id = 243
// module chunks = 1